import { define } from 'wicked-elements'
import Flickity from 'flickity'
import 'flickity/dist/flickity.css'
import onIntersect from '../lib/on-intersect.js'
import options from '../lib/options.js'

/**
 * Minimal slideshow that just cycles through images
 * without transitions, and without UI. Doesn't *need*
 * Flickity, but the slideshows in the Studio section
 * are built with Flickity, so we use for consistency
 */

define('[data-component~="inline-cycle"]', {
  init () {
    this.options = options(this.element.getAttribute('data-options'))
    this.timer = null

    this.$slider = this.element.querySelector('.slider')
  
    this.play = this.play.bind(this)
    this.pause = this.pause.bind(this)
    this.popNext = this.popNext.bind(this)
    this.popPrev = this.popPrev.bind(this)
    this.handleIntersect = this.handleIntersect.bind(this)
  },
  connected () {
    this.flkty = new Flickity(this.$slider, {
      wrapAround: true,
      prevNextButtons: false,
      pageDots: false,
      draggable: false
    })

    this.stopObserving = onIntersect(this.element, this.handleIntersect, this.handleIntersect)
  },
  disconnected () {
    this.stopObserving()
  },
  popNext () {
    this.flkty.next(true, true)
  },
  popPrev () {
    this.flkty.previous(true, true)
  },
  play () {
    this.pause()
    this.timer = setInterval(() => {
      this.popNext()
    }, this.options.speed || 2500)
  },
  pause () {
    clearInterval(this.timer)
  },
  handleIntersect (e) {
    if (e.intersectionRatio === 0) {
      this.pause()
    } else {
      this.play()
    }
  }
})